/** Clips data only exists inside this window. The picker can move within it. */
export const CLIPS_EXPLORER_START_DATE = '2026-10-15';
export const CLIPS_EXPLORER_END_DATE = '2026-11-02';

export function clipsExplorerPeriod(
    clipsIa: boolean,
    startDate: string,
    endDate: string,
    minDate?: string,
    maxDate?: string,
): { startDate: string; endDate: string; minDate?: string; maxDate?: string } {
    if (!clipsIa) return { startDate, endDate, minDate, maxDate };
    return {
        ...clampToClipsWindow(startDate, endDate),
        minDate: CLIPS_EXPLORER_START_DATE,
        maxDate: CLIPS_EXPLORER_END_DATE,
    };
}

/** Keep a selected range inside the clips window. A range with no overlap uses the whole window. */
export function clampToClipsWindow(
    startDate: string,
    endDate: string,
): { startDate: string; endDate: string } {
    const min = CLIPS_EXPLORER_START_DATE;
    const max = CLIPS_EXPLORER_END_DATE;
    let start = startDate;
    let end = endDate;
    if (start > end) [start, end] = [end, start];
    if (end < min || start > max) return { startDate: min, endDate: max };
    if (start < min) start = min;
    if (end > max) end = max;
    return { startDate: start, endDate: end };
}
